import React, { useEffect, useState, useMemo } from "react";
// import Typed from 'typed.js';
import "./Herobody.css";
import "./Bluesection.css";
// import { Link } from "react-router-dom";
// import { Splide, SplideSlide } from '@splidejs/react-splide';
// import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import "./MySlider.css";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./Counter.css";
import Images4 from "../../Images/newimg4.png";
import outlooklogo from "../../Images/outlook.png";
import zeeImage from "../../Images/zee.png";
import wireIndiaImage from "../../Images/wireindia.png";
import theWeekImage from "../../Images/theweek.png";
import brandzLogo from "../../Images/logob.png";
import lovingHeartsLogo from "../../Images/loving-hearts-logo.png";
// import Images11 from "../../Images/img-1.png";
// import Images12 from "../../Images/img-2.png";
// import Images13 from "../../Images/img-3.png";
// import Images14 from "../../Images/img-4.png";
// import Images15 from "../../Images/img-5.png";
export default function Home() {
  const [counterOn, setCounterOn] = useState(false);
  // const textItems = ['Minimising Cost', 'Increasing Productivity', 'Reducing Risk', 'Sustaining Growth'];
  const textItems = useMemo(
    () => [
      "Minimising Cost",
      "Increasing Productivity",
      "Reducing Risk",
      "Sustaining Growth",
    ],
    [],
  );
  const [index, setIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const text = textItems[index];

    if (isTyping) {
      const interval = setInterval(() => {
        if (charIndex < text.length) {
          setDisplayText((prevText) => prevText + text[charIndex]);
          setCharIndex((prevIndex) => prevIndex + 1);
        } else {
          setIsTyping(false);
          clearInterval(interval);
        }
      }, 100);

      return () => clearInterval(interval);
    } else {
      const timeout = setTimeout(() => {
        setDisplayText("");
        setCharIndex(0);
        setIndex((prevIndex) => (prevIndex + 1) % textItems.length);
        setIsTyping(true);
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [index, charIndex, textItems, isTyping]);
  // const typedRef=useRef(null)
  // useEffect(() =>{
  //     const options={
  //     strings:[
  //         "Increasing Productivity",
  //         "Random Text XYZ-1",
  //         " Another Random Text XYZ-1",
  //     ],
  //     typeSpeed: 50,
  //     backSpeed:50,
  //     loop:true,
  // };
  // const typed=new Typed(typedRef.current,options)
  // return ()=>{
  //     typed.destroy()
  // }
  // },[])
  return (
    <>
      <section>
        <div id="up-showcase">
          {/* <div id="jobtitle">
                        <p >HR Labs, where human-centered HR consulting meets
                            transformative solutions.</p>
                    </div> */}
          <div id="showcase">
            <div className="homeimgbox">
              <h2>Helping Startups, SMEs and brands in : </h2>
              <strong className="text-sliderbox">{displayText}</strong>
            </div>

            <div className="home-cont">
              HR Labs Where human-centered HR consulting meets <br />
              transformative solutions
            </div>
          </div>

          <div className="home-image2">
            <img src={Images4} alt=" " width="300px" height="300px" />
          </div>
        </div>
      </section>

      {/* <section>
        <div id="down-photo">
          <div id="iconsfi">
            <div>
              <Link to="/Consulting">
                <img src={Images11} alt="" />
              </Link>
            </div>
            <div>
              <Link to="/Consulting">
                <img src={Images12} alt="" />
              </Link>
            </div>
            <div>
              <Link to="/Consulting">
                <img src={Images13} alt="" />{" "}
              </Link>
            </div>
            <div>
              <Link to="/Consulting">
                <img src={Images14} alt="" />{" "}
              </Link>
            </div>
            <div>
              <a href="/" target="_blank">
                <img src={Images15} alt="" />
              </a>
            </div>
          </div>
        </div>
      </section> */}
      <section>
        <div className="main-depo">
          <div className="depo">
            <div className="head-depo">
              <h1>Our Department Suite</h1>
            </div>
            <div id="para1">
              <p>
                Have invested over 18+ Years in Learning, understanding,
                implementing & turning non-performing organizations to a
                profitable business.
              </p>
            </div>
            <div id="para2">
              <p>
                On Mission to Help 1,00,000 Startups with Effective People,
                Process & Performance Management System.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="slider">
          <div id="slider-heading">
            <h1>Have been featured in:</h1>
          </div>
          <div id="img-slider">
            <Splide
              id="container"
              options={{
                type: "loop",
                perPage: 4,
                perMove: 4,
                arrows: false,
              }}
            >
              <SplideSlide>
                <div className="slide-image-container">
                  <img src={outlooklogo} alt="" />
                </div>
              </SplideSlide>
              <SplideSlide>
                <div className="slide-image-container">
                  <img src={brandzLogo} alt="" />
                </div>
              </SplideSlide>

              <SplideSlide>
                <div className="slide-image-container">
                  <img src={zeeImage} alt="" />
                </div>
              </SplideSlide>
              <SplideSlide>
                <div className="slide-image-container">
                  <img src={theWeekImage} alt="" />
                </div>
              </SplideSlide>
              <SplideSlide>
                <div className="slide-image-container" id="inc">
                  <img src={wireIndiaImage} alt="" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
      </section>
      {/* NGO PARTNER */}
      <section className="py-10 bg-secondary">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <p className="text-xs tracking-[0.3em] text-primary font-bold mb-3">
            Our NGO Partner
          </p>

          <div className="max-w-2xl mx-auto bg-background rounded-3xl p-8 md:p-10 shadow-[var(--shadow-elegant)] border border-border">
            <div className="flex flex-col items-center">
              <img
                src={lovingHeartsLogo}
                alt="Loving Hearts — NGO Partner"
                className="h-24 md:h-28 object-contain mb-6"
              />

              <div className="w-16 h-1 bg-primary rounded-full mb-6" />

              <p className="text-muted-foreground leading-relaxed max-w-lg">
                Committed to transforming lives through education, nutrition,
                and compassionate care. Together, we empower underprivileged
                children, strengthen communities, and create sustainable social
                impact that inspires hope and opportunity for generations to
                come.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div id="main-counter">
          <div id="counter">
            <div id="counter-heading">
              <p>Crafted in India | Designed for Global Excellence.</p>
            </div>
            <div id="counter-page">
              <div>
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <div>
                    <h2>
                      {counterOn && (
                        <CountUp start={0} end={50} duration={2} Delay={0} />
                      )}
                      +
                    </h2>
                    <p>Companies</p>
                  </div>
                </ScrollTrigger>
              </div>
              <div>
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <div>
                    <h2>
                      {counterOn && (
                        <CountUp start={0} end={6} duration={2} Delay={0} />
                      )}
                      +
                    </h2>
                    <p>States</p>
                  </div>
                </ScrollTrigger>
              </div>
              <div>
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <div>
                    <h2>
                      {counterOn && (
                        <CountUp start={0} end={90} duration={2} Delay={0} />
                      )}
                      +
                    </h2>
                    <p>Projects</p>
                  </div>
                </ScrollTrigger>
              </div>
              <div>
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <div>
                    <h2>4.8/5</h2>
                    <p>Ratings</p>
                  </div>
                </ScrollTrigger>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
